const __vitePreload = (fn) => fn();
const getFormValidator = async (form, addressTemplates, validationMode) => {
  const [{ FormValidator }, { MultilineAddressToolkit }] = await Promise.all([
    __vitePreload(() => import(
      /* webpackChunkName: "form-validator" */
      "@wix/form-validator"
    ), true ? [] : void 0),
    __vitePreload(() => import(
      /* webpackChunkName: "form-multiline-address" */
      "@wix/form-multiline-address"
    ), true ? [] : void 0)
  ]);
  if (addressTemplates?.length) {
    const addressForms = addressTemplates.map((template) => template.template);
    const addressToolkit = new MultilineAddressToolkit(addressForms);
    return new FormValidator(
      [form],
      validationMode,
      false,
      addressToolkit.getFormForValidation,
      addressToolkit.normalizeEmptyValues,
      true
    );
  }
  return new FormValidator(
    [form],
    validationMode,
    void 0,
    void 0,
    void 0,
    true
  );
};
const validate = async (form, values, addressTemplates, validationMode) => {
  if (!form.id) {
    return;
  }
  const formValidator = await getFormValidator(
    form,
    addressTemplates,
    validationMode
  );
  return formValidator.validate(form.id, values);
};
const validateFields = async (form, values, addressTemplates, validationMode) => {
  if (!form.id) {
    return;
  }
  const formValidator = await getFormValidator(
    form,
    addressTemplates,
    validationMode
  );
  return formValidator.validateFields(form.id, values);
};
export {
  validate,
  validateFields
};
//# sourceMappingURL=validation.js.map
